import React from 'react';

var ClockIcon = function ClockIcon(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? "" : _ref$ariaLabel;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    role: "img",
    width: "14",
    height: "14",
    "aria-label": ariaLabel,
    style: {
      display: "block",
      margin: "0 auto",
      fill: "#666"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Zm7-3.25v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5a.75.75 0 0 1 1.5 0Z"
  }));
};
ClockIcon.displayName = "ClockIcon";

export { ClockIcon as default };
